import * as React from 'react';
import { Grid, makeStyles, createStyles, Card, CardActionArea, CardMedia, CardContent, Typography, Theme } from '@material-ui/core';
import { _PortalState } from 'src/helpers/state';
import { Link } from 'react-router-dom'

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        card: {
            // padding: theme.spacing(2),
            maxWidth: 345,
        },
        media: {
            height: 180,
        },
    }),
);

const Videos: React.FC = () => {

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Grid container={true} justify="center" spacing={3}>

                {_PortalState.videos.map(v => {
                    return (
                        <Grid key={v.id} item={true} xs={12} md={6} lg={4}>
                            <Link to={"/video/" + v.id} style={{ textDecoration: 'none' }}>
                                <Card className={classes.card}>
                                    <CardActionArea>
                                        <CardMedia
                                            className={classes.media}
                                            image={"/images/video/" + v.id + ".png"}
                                            title={v.Title}
                                        />
                                        <CardContent>
                                            <Typography gutterBottom={true} variant="h6" component="h2">
                                                {v.Title}
                                            </Typography>
                                            {/* <Typography variant="body2" color="textSecondary" component="p">
                                        Lizards are a widespread group of squamate reptiles, with over 6,000 species, ranging
                                        across all continents except Antarctica
                        </Typography> */}
                                        </CardContent>
                                    </CardActionArea>
                                    {/* <CardActions>
                                <Button size="small" color="primary">
                                    Share
                      </Button>
                                <Button size="small" color="primary">
                                    Learn More
                      </Button>
                            </CardActions> */}
                                </Card>
                            </Link>

                        </Grid>
                    );
                })}

            </Grid>
        </div >
    );

}

export default Videos;


// WEBPACK FOOTER //
// ./src/components/video/Videos.tsx